import { ApiClient } from '../api-client';

const ComplianceApi = ApiClient.service.compliance;
/**
 *  useComplianceApi is a hook that returns a reusable axios instance with auth
 * @returns {AxiosInstance}
 */
const useComplianceApi = () => {
  return ComplianceApi;
};

export { ComplianceApi, useComplianceApi };
